module.exports = __webpack_public_path__ + "img/5.e6ef6b63.jpg";